import React from "react";
import { AnalyticsContext } from "../context/analyticsContext";
import { IAppointment } from "../interface/iAppointment";
import { IAppointmentFilter } from "../interface/iAppointmentFilter";
import { ISearchResults } from "../interface/iSearchResults";
import FilterCheckbox from "../../../../components/inputs/filterCheckbox/filterCheckbox";

const FilterCheckboxes = () => {
  const {
    searchResults,
    appointmentFilter,
    setAppointmentFilter,
  }: {
    searchResults: ISearchResults;
    appointmentFilter: IAppointmentFilter;
    setAppointmentFilter: React.Dispatch<
      React.SetStateAction<IAppointmentFilter>
    >;
  } = React.useContext(AnalyticsContext);

  const getActiveCount = (): number =>
    searchResults.appointmentList.appointments?.filter(
      (appointment: IAppointment) =>
        appointment.status === "G" && new Date(appointment.date) >= new Date(),
    ).length;

  const activeClickHandler = (): void =>
    setAppointmentFilter({
      ...appointmentFilter,
      active: !appointmentFilter.active,
    });

  const getCompletedCount = (): number =>
    searchResults.appointmentList.appointments?.filter(
      (appointment: IAppointment) =>
        appointment.status === "G" && new Date(appointment.date) < new Date(),
    ).length;

  const compledtedClickHandler = (): void =>
    setAppointmentFilter({
      ...appointmentFilter,
      completed: !appointmentFilter.completed,
    });

  const getFreeCount = (): number =>
    searchResults.appointmentList.appointments?.filter(
      (appointment: IAppointment) => appointment.status === "F",
    ).length;

  const freeClickHandler = (): void =>
    setAppointmentFilter({
      ...appointmentFilter,
      free: !appointmentFilter.free,
    });

  const getMissedCount = (): number =>
    searchResults.appointmentList.appointments?.filter(
      (appointment: IAppointment) => appointment.status === "V",
    ).length;

  const missedClickHandler = (): void =>
    setAppointmentFilter({
      ...appointmentFilter,
      missed: !appointmentFilter.missed,
    });

  const getCancelledCount = (): number =>
    searchResults.appointmentList.appointments?.filter(
      (appointment: IAppointment) => appointment.status === "K",
    ).length;

  const cancelledClickHandler = (): void =>
    setAppointmentFilter({
      ...appointmentFilter,
      cancelled: !appointmentFilter.cancelled,
    });

  return (
    <React.Fragment>
      <FilterCheckbox
        badgeContent={getActiveCount()}
        onClickHandler={activeClickHandler}
        label="Aktiv"
        checked={appointmentFilter.active}
      />

      <FilterCheckbox
        badgeContent={getCompletedCount()}
        onClickHandler={compledtedClickHandler}
        label="Durchgeführt"
        checked={appointmentFilter.completed}
      />

      <FilterCheckbox
        badgeContent={getFreeCount()}
        onClickHandler={freeClickHandler}
        label="Frei"
        checked={appointmentFilter.free}
      />

      <FilterCheckbox
        badgeContent={getMissedCount()}
        onClickHandler={missedClickHandler}
        label="Versäumt"
        checked={appointmentFilter.missed}
      />

      <FilterCheckbox
        badgeContent={getCancelledCount()}
        onClickHandler={cancelledClickHandler}
        label="Storniert"
        checked={appointmentFilter.cancelled}
      />
    </React.Fragment>
  );
};

export default FilterCheckboxes;
